import React from 'react';

import { BuilderLinkButton } from '../../../Shared/components/common/LinkButton';

interface Props {
    builderUrl: string;
    isReadonly: boolean;
}
export default class InvalidCharacter extends React.PureComponent<Props> {
    render() {
        const { builderUrl, isReadonly } = this.props;

        return (
            <div className="ct-invalid-character">
                <h2>Character Not Ready!</h2>

                <p>
                    The current character is not accessible because it is missing either a <strong>Race</strong>,{' '}
                    <strong>Class</strong> or <strong>Ability Scores</strong>.
                </p>

                {!isReadonly && (
                    <React.Fragment>
                        <p>Return to the character builder to complete the character creation process.</p>

                        <p>
                            <BuilderLinkButton
                                url={builderUrl}
                                className="ct-invalid-character__button"
                                size="oversized"
                            >
                                Character Builder
                            </BuilderLinkButton>
                        </p>
                    </React.Fragment>
                )}
            </div>
        );
    }
}
